class ShareButton extends HTMLElement {
  constructor() {
    super();
    
    this.urls = {
      facebook: 'https://www.facebook.com/sharer/sharer.php?u=',
      twitter: 'https://twitter.com/intent/tweet?original_referer=&url='
    };

    this.buttons = this.querySelectorAll('.social-share');
    this.pageUrl = window.location.href;

    this.buttons.forEach(button => {
      button.addEventListener('click', () => {
        let type = button.getAttribute('js-social');
        let url = this.urls[type];

        this.openShareWindow(url, type);
      });
    });
  }

  openShareWindow(url, type) {
    window.open(url + this.pageUrl, `${type}-share-dialog`, 'width=800,height=600');
  }
}

customElements.define('share-button', ShareButton);